import { faCheck, faCheckCircle, faExclamation, faExclamationCircle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';
import { MiscContext } from '../../../context/misc.context';
import Enums from '../../../enums';
import IconButton from '../../_controls/IconButton/IconButton';
import '../Popup.sass';
import './PromptPopup.sass';


const PromptPopup = () => {

    // <> Context
    const { openPopup, openPopupState, setOpenPopup } = useContext(MiscContext);

    // <> States
    const [text, setText] = useState('');

    // <> Actions
    function closePopup() {
        setOpenPopup('');
    }

    function onOk() {
        if(openPopupState.onOk) openPopupState.onOk(text);
        setOpenPopup('');
    }

    // <> JSX
    return (
        <div className={`prompt-popup popup ${openPopup == Enums.PopupTags.Prompt ? 'popup--show' : ''}`}>

            {/* Overlay */}
            <div className="popup__overlay" onClick={closePopup}></div>

            {/* Container */}
            <div className="popup__container prompt-popup__container">

                {/* Icon */}
                <div className={`prompt-popup__container__icon ${openPopupState.level ? `prompt-popup__container__icon--${openPopupState.level}` : ''}`}>
                    {openPopupState.level == 'info' && <FontAwesomeIcon icon={faInfoCircle} />}
                    {openPopupState.level == 'success' && <FontAwesomeIcon icon={faCheckCircle} />}
                    {openPopupState.level == 'warning' && <FontAwesomeIcon icon={faExclamationCircle} />}
                    {openPopupState.level == 'danger' && <FontAwesomeIcon icon={faExclamationCircle} />}
                </div>

                {/* Body */}
                <div className="prompt-popup__container__body">

                    {/* Top */}
                    <div className="prompt-popup__container__body__top">
                        <div className="prompt-popup__container__body__top__title">{openPopupState.title}</div>
                    </div>

                    {/* Content */}
                    <div className="prompt-popup__container__body__content">
                        <div className="prompt-popup__container__body__content__message">{openPopupState.message}</div>
                    </div>

                    {/* Input */}
                    <div className="prompt-popup__container__body__input">
                        <input 
                            className="prompt-popup__container__body__input__control"
                            value={text}
                            onChange={ev => setText(ev.target.value)} />
                    </div>

                    {/* Actions */}
                    <div className="prompt-popup__container__body__actions">
                        <IconButton
                            text={openPopupState.cancelButtonText || 'Cancel'}
                            icon={faTimes}
                            btnStyle={'faded'}
                            onClickFn={closePopup} />
                        <IconButton
                            text={openPopupState.okButtonText || 'Ok'}
                            icon={faCheck}
                            isDisabled={text.length < 3}
                            btnStyle={'success'}
                            onClickFn={onOk} />
                    </div>

                </div>


            </div>
        </div>
    );
};

export default PromptPopup;